export default "__VITE_ASSET__d53e90dd__"